import React from 'react';

type AlertInfoProps = {
	icon: any;
	content: string | JSX.Element;
	margin: string;
};

export const AlertInfo = ({ icon, content, margin }: AlertInfoProps) => {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				margin: margin,
			}}
		>
			{icon}
			<p className="small-bold gris-6" style={{ marginLeft: 8 }}>
				{content}
			</p>
		</div>
	);
};
